import { bindable, BindingMode, inject } from "aurelia";

@inject(Element)
export class TextareaexCustomElement {
  @bindable({ mode: BindingMode.twoWay }) value;
  @bindable rows;
  @bindable maxlength;
  @bindable placeholder;
  @bindable disabled;
  @bindable counter;
  @bindable tabindex;
  @bindable large;
  @bindable py;
  @bindable px;
  @bindable noborder;
  @bindable breakword;
  @bindable id;

  constructor(element) {
    this.element = element;
    this.border = null;
  }

  attached() {
    if (this.id) {
      this.textarea.id = this.id;
      this.element.removeAttribute("id");
    }
    if (!this.placeholder) this.placeholder = "";
    if (this.counter == null) this.counter = true;
    if (this.counter === "false") this.counter = false;
    if (!this.maxlength) this.maxlength = 200;
    if (this.noborder === "true") this.border = 0;
    if (!this.breakword) this.breakword = false;
    if (this.breakword === "true") this.breakword = true;
    if (this.breakword === "false") this.breakword = false;

    this.element.addEventListener("focus", () => {
      this.textarea.focus();
    });
  }
}
